import React from "react";
import HRLayout from "../layout/HRLayout";

const LeaveManagement = () => {
  const data = [
    {
      name: "Sonam",
      type: "Casual Leave",
      from: "2026-03-28",
      to: "2026-03-30",
      days: 3,
      status: "Pending",
    },
  ];

  return (
    <HRLayout>
      <h2 className="text-2xl font-bold mb-4">Leave Management</h2>

      <div className="bg-white p-4 rounded shadow">
        <table className="w-full">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Type</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td>{item.name}</td>
                <td>{item.type}</td>
                <td>{item.from}</td>
                <td>{item.to}</td>
                <td>{item.days}</td>
                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </HRLayout>
  );
};

export default LeaveManagement;